import React from "react";
import { Link } from "react-router-dom";

const services = [
  {
    category: "Haldi",
    name: "Kanak",
    description: "Wrapped in Haldi radiance, ensembles designed for the warmth of the day",
    image: "/image/haldi-service.webp",
  },
  {
    category: "Mehandi",
    name: "Anjum",
    description: "Celebrating patterns of love, with intricate detailing for the occasion",
    image: "/image/mehandi-service.webp",
  },
  {
    category: "Sangeet",
    name: "Ada",
    description: "Style set to rhythm, made to move with you through the night",
    image: "/image/sangeet-service.webp",
  },
  {
    category: "Wedding",
    name: "Banno",
    description: "Royal grace, redefined for the bride who wants her ensemble to feel like destiny",
    image: "/image/wedding-banner.webp",
  },
  {
    category: "Festive",
    name: "Mittrika",
    description: "Contemporary and celebration-ready pieces for every family occasion beyond the wedding",
    image: "/image/festive-service.webp",
  },
];

export default function Services() {
  return (
    <section className="journey-services">
      <div className="container">
        <div className="journeyservices-head">
          {/* <span className="gradient-color">Services</span> */}
          <h2 className="heading">Ensembles for Every Moment</h2>
          <p>A bespoke ensemble for every celebration on your calendar, each one shaped around your story.</p>
        </div>

        <div className="row justify-content-center servicecard-row">
          {services.map((service, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="servicecard-box">
                <img src={service.image} className="img-responsive" alt={service.category} loading="lazy" />
                <h4 className="heading">
                  {service.category} <span className="gradient-color">— {service.name}</span>
                </h4>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="journeyservices-btn">
          <Link to="/contact-us#contact-form" className="default-btn red-default">
            Begin My Story
          </Link>
        </div>
      </div>
    </section>
  );
}
